import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    id: null,
    email: '',
    accounts: {},
    active: {}, // Use an empty object for consistency
    name: '',
    profilePicture: '',
};

const saveToStorage = (state) => {
    localStorage.setItem('user', JSON.stringify(state));
};

const clearFromStorage = () => {
    localStorage.removeItem('user');
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            const newState = {
                ...state,
                ...action.payload,
            };
            saveToStorage(newState);
            return newState;
        },
        clearUser: () => {
            // Reset to the initial state
            clearFromStorage();
            return initialState;
        },
        rehydrateUser: () => {
            try {
                const stored = JSON.parse(localStorage.getItem('user'));
                if (stored) {
                    return stored;
                }
                return initialState;
            } catch {
                return initialState;
            }
        },
    },
});

export const { setUser, clearUser, rehydrateUser } = userSlice.actions;
export default userSlice.reducer;
